
import axios from 'axios'
import { apiBaseURL, auth, SECRET_KEY } from './Utility';
import CryptoJS from "crypto-js";

export const axiosInstance = axios.create({
    baseURL: apiBaseURL(),
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        if (config.data instanceof FormData) {
            config.headers['Content-Type'] = 'multipart/form-data';
        } else {
            config.headers['Content-Type'] = 'application/json';
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

function getAuthToken() {
    return auth('user')?.token || auth('admin')?.token
}
export const APICALL = async (endPoint = '', method = 'GET', value = null) => {
    try {
        let payload = null;
        if (value) {
            const encryptedData = CryptoJS.AES.encrypt(
                JSON.stringify(value),
                SECRET_KEY
            ).toString();
            payload = { payload: encryptedData };
        }

        const response = await axiosInstance({
            method: method,
            url: endPoint,
            data: payload
        });

        // ✅ decrypt success response
        const encrypted = response.data;
        const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
        const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return decrypted;

    } catch (error) {
        try {
            // ✅ decrypt error response if encrypted
            if (error?.response?.data) {
                const encryptedError = error.response.data;
                const bytes = CryptoJS.AES.decrypt(encryptedError, SECRET_KEY);
                const decryptedError = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                console.error("Decrypted Error:", decryptedError);
                return Promise.reject(decryptedError);
            }
        } catch (decryptErr) {
            console.error("Error decrypting error response:", decryptErr);
        }

        // fallback if not encrypted
        return Promise.reject({
            status: error?.response?.status || 500,
            message: error?.message || "Unknown error"
        });
    }
};
